// SECTIONS

import {
    constables
} from './base.js';

const breakpoint = constables().breakpoint;

const times = constables().times;
const timem = constables().timem;
const timel = constables().timel;

let mind = {
    vh: 0,
    scale: [],
    frame: 0
}
let frame;

// INIT

export function initkalender() {

    routes();

}

function routes() {

    // STACK CLICK

    let list = document.querySelectorAll('section.kalender-list');
    list.forEach(ul => {

        buildStack(ul);

    })

    // STACK TRANSITION

    // window.addEventListener('resize', resize);
    // resize();
    // initscaling();

}

function resize() {

    mind.vh = window.innerHeight / 2;

};

function buildStack(ul) {

    let index = ul.querySelectorAll('ul').length;

    if (index > 7) {

        let stack = ul.querySelector('section.kalender-stack');
        stack.addEventListener('click', () => {

            addStack(ul, index);

        });

    }

}

function addStack(ul, index) {

    let stack = parseInt(ul.dataset.stack);
    if (stack < index) {
        stack += 7;
        ul.dataset.stack = stack;
        let li = ul.querySelectorAll('ul');
        li.forEach((l, i) => {
            if (i < stack) {
                l.classList.add('aktiv');

                if (i == stack - 8) {
                    let top = l.getBoundingClientRect().bottom;

                    window.scrollTo({
                        top: top + window.scrollY,
                        behavior: "smooth",
                    });

                }
            }
        })


    }
    if (stack + 1 > index) {
        ul.classList.add('stacked');
    }

}


function initscaling() {

    let list = document.querySelectorAll('ul.kalender');

    if (typeof list !== 'undefined' && list.length > 0) {

        let observer;

        let options = {
            root: null,
            rootMargin: "0px",
            threshold: [0]
        };

        observer = new IntersectionObserver(scaleIntersect, options);

        list.forEach((el, index) => {
            observer.observe(el);
        })

    }

}

function scaleIntersect(entries, observe) {

    entries.forEach(entry => {

        if (entry.isIntersecting) {

            mind.scale.push(entry.target);

        } else {

            mind.scale.forEach((m, index) => {

                if (m == entry.target) {
                    mind.scale.splice(index, 1);
                }

            })

        }

    })

    scrollframe();

}

function scrollframe() {

    mind.scale.forEach(m => {

        let b = m.getBoundingClientRect();
        let x = (b.top - mind.vh) / mind.vh;
        if (x >= 0) {
            let c = (Math.cos(Math.PI * x) + 1) / 2;
            m.style.transform = 'scale(' + c + ')';
        } else {

            m.style.transform = 'scale(' + 1 + ')';
        }

    })

    if (mind.scale.length) {

        requestAnimationFrame(scrollframe);

    }

}